<template>
  <a class="col-6 col-md-4 col-lg-3 decoration-none" :href="`/${routeDescription}/${id}`">
    <div class="card mb-2 w-100 pointer container-card-car">
      <div class="d-flex flex-column display-colors-available-catalogue mb-8">
        <span class="pointer-color-selector v2 grey"></span>
        <span class="pointer-color-selector v2 black"></span>
        <span class="pointer-color-selector v2 orange"></span>
      </div>
      <p class="model-car-background">{{ carModel || '' }}</p>
      <div class="card-body-img">
        <img :src="urlBackgroundImage" class="card-img-top car-photo"
             :alt="carModel"
        />
      </div>
      <div class="card-body">
        <h5 class="card-title text-center font-weight-bold mb-0 mt-2">{{ carModel || '' }}</h5>
        <h6 class="text-center">{{ getReleaseYear || 0 }}</h6>
        <p v-if="showInitialPayment || showTotalPayment" class="card-text text-center mb-8" style="font-size: 16px;">
          Comienza desde {{
            Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}).format(initialPayment) || 0
          }}
        </p>
        <p class="card-text text-center mb-8" style="font-size: 16px;">Disponible</p>
        <p v-if="showMontlyPayment" class="card-text text-center mb-16 car-pricing-catalogue">
          {{
            Intl.NumberFormat('es-MX', {
              style: 'currency',
              currency: 'MXN'
            }).format(monthlyCost) || 0
          }} mensual
        </p>
        <a
          :href="`/${routeDescription}/${id}`"
          class="btn btn-primary d-block mx-auto-detalle "
          style="border-radius: 0px;"
        >
          Estoy interesado
        </a>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  name: 'CocheCard',
  computed: {
    getReleaseYear: function () {
      const ry = this.releaseYear.split(' ')
      return ry[ry.length - 1]
    }
  },
  props: {
    routeDescription: {
      type: String,
      required: false,
      default: 'description'
    },
    id: [Number, String],
    urlBackgroundImage: String,
    carModel: String,
    releaseYear: String,
    initialPayment: Number,
    monthlyCost: Number,
    stock: [String, Number],
    colors: String,
    showMontlyPayment: {
      type: Boolean,
      default: true
    },
    showInitialPayment: {
      type: Boolean,
      default: true
    },
    showTotalPayment: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    splt(arg1) {
      // j
    }
  }
}
</script>
<style scoped>
.decoration-none {
  text-decoration: none;
}

</style>
